const links = {
  "links.CLI_repository": "https://cli.pimcore.cloud/",
  "links.blackfire.connect": "https://blackfire.io/session/connect/pimcore",
  "links.documentation.download_code":
    "https://docs.pimcore.com/platform/Paas/",
  "links.documentation.wizard": "https://docs.pimcore.com/platform/Paas/",
  "links.website": "https://pimcore.com/en"
};

export default links;
